import { getMicrosoftSettings } from 'services/authorization/authorization.service';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IMicrosoftSettings } from 'services/authorization/types';

export const ThunkGetMicrosoftSettings = createAsyncThunk<IMicrosoftSettings>(
  'authorization/getMicrosoftSettings',
  () => getMicrosoftSettings().then(res => res.data),
);
